export const FULL_RANGE_RULER_WIDTH_PX = 32;
/**
 * Height of the core lane ruler
 * @type {number}
 */
export const LANE_RULER_HEIGHT_PX = 20;
/**
 * Threshold that will switch core lane ruler to show/hide
 * @type {number}
 */
export const LANE_RULER_SCALE_THRESHOLD = 1500;
export const MINIMUM_INITIAL_PX_M = 500;

/**
 * The default max resolution of imagery if it cannot be determined from metadata
 */
export const DEFAULT_MAX_RESOLUTION = 7500;
